import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'

export const SHIPMENT_ACTION_TYPES = generateApiActionTypes('SHIPMENT')

export const getShipment = (id: number | string, token?: string, includeParams?: boolean) => {
  const params = includeParams
    ? {
        includes: [
          'project44_metadata',
          'driver_tracking_information',
          'shipper_insurance_requirement',
          'auto_appts',
        ],
      }
    : {}
  const requestData = {
    endpoint: ENDPOINTS.shipments,
    id,
    params,
    ...(token && { params: { easyAccessToken: token } }),
  }
  return {
    type: '',
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(SHIPMENT_ACTION_TYPES),
    },
  }
}
